import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { RiskAssessmentQuestionnaireItem } from './questionnaire'

export const RISK_ASSESSMENT_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOSPITALIZATION_RISK]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOSPITALIZATION_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_TRIAGE_CODE]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_EMERGENCY_PLAN]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_SAFE_ROOM]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FIRE_ASSESSMENT_OXYGEN]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FIRE_SAFETY_PRECAUTIONS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_HOMEBOUND_STATUS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_INFECTION_RISK]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_INFECTION_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK_FACTORS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FALL_RISK_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_FINANCE_RISK]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_ENVIRONMENT_SAFETY]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_NURSE_SAFETY_RISKS]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_SAFETY_MEASURES]:
    QuestionnaireAnswerType.STRING,
  [RiskAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_RISK_ASSESSMENT_NOTES]:
    QuestionnaireAnswerType.STRING
}
